import { QuadPosition, } from '@ontologies/core';
import { hextupleStringParser } from './hextupleStringParser';
export class HextuplesRDFLibParser {
    constructor(store, errorHandler = console.error) {
        this.store = store;
        this.rdfFactory = store.rdfFactory;
        this.errorHandler = errorHandler;
    }
    loadBuf(str) {
        this.addArr(this.parseString(str));
    }
    parseString(str) {
        return hextupleStringParser(str, this.rdfFactory).map((q) => [
            q.subject,
            q.predicate,
            q.object,
            q.graph,
        ]);
    }
    addArr(quads) {
        let q;
        for (let i = 0, len = quads.length; i < len; i++) {
            q = quads[i];
            if (q) {
                this.store.add(q[QuadPosition.subject], q[QuadPosition.predicate], q[QuadPosition.object], q[QuadPosition.graph]);
            }
        }
    }
}
